@if (isOpen()) {
<div class="modal-backdrop" (click)="onBackdropClick()" (keydown)="onKeyDown($event)" tabindex="0">
  <div class="modal-container" [class]="'modal-' + config()?.type">
    <h2 class="modal-title">{{ config()?.title }}</h2>
    <p class="modal-message">{{ config()?.message }}</p>

    @if (config()?.showInput) {
      <input
        type="text"
        class="modal-input"
        [placeholder]="config()?.inputPlaceholder"
        [value]="inputValue()"
        (input)="onInputChange($any($event.target).value)"
        (keydown)="onInputKeyDown($event)"
        autofocus
      />
    }

    <div class="modal-actions">
      <button class="modal-btn modal-btn-cancel" (click)="onCancel()" type="button">
        {{ config()?.cancelText }}
      </button>
      <button
        class="modal-btn modal-btn-confirm"
        (click)="onConfirm()"
        type="button"
        [disabled]="config()?.showInput && !inputValue().trim()"
      >
        {{ config()?.confirmText }}
      </button>
    </div>
  </div>
</div>
}
